// extracted by mini-css-extract-plugin
export default {"title_delete":"DeleteUser_title_delete__nDQwt","title_edit":"DeleteUser_title_edit__EyNod"};